var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { generateStubLinkReport } from "@here/indoor-map-utilities/qa";
import { getSnapshots } from "../../api/internalTools";
import { getAllCollectionData, getMomFromIML, getQAReport, postSnapshots, refreshDefaultLayer, viewCheckinReport, } from "../../api/venues";
import { INDOOR_MAP, NOTIFICATION_VARIANT } from "../../store/common/constants";
import { setMapInCollectionList } from "../../store/reducers/appSlice";
import translations from "../../translations/resources/en-GB.json";
import { DOWNLOAD_COLLECTION_TOAST, DOWNLOAD_STUB_LINK_TOAST, MAP_COLLECTION_DROPDOWN_VALUES, REFRESH_COLLECTION_TOAST, VIEW_CHECKIN_REPORT_TOAST, VIEW_QA_REPORT_TOAST, } from "./constants";
import utils from "../../store/helpers/indoorHelper";
import { generateAttributeCount } from "@here/indoor-map-utilities/attributeCountReport";
export var isSharedCollectionHrn = function (hrn, realm) {
    return !hrn.includes(":".concat(realm, ":"));
};
export var mapDetails = function (hrn, collectionMetaList, history) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var collectionList, collectionListObj;
        return __generator(this, function (_a) {
            collectionList = collectionMetaList.find(function (c) { return c.hrn === hrn; });
            collectionListObj = {
                maps: collectionList === null || collectionList === void 0 ? void 0 : collectionList.mapsInCollection,
                collectionName: collectionList === null || collectionList === void 0 ? void 0 : collectionList.name,
                collectionHrn: hrn,
                latestSnapshot: collectionList === null || collectionList === void 0 ? void 0 : collectionList.latestSnapshot,
            };
            dispatch(setMapInCollectionList(collectionListObj));
            history.push({
                pathname: "/",
                search: window.location.search,
                state: { isMapCollectionDetails: true },
            });
            return [2 /*return*/];
        });
    }); };
};
export var copyCollectionUrl = function (hrn, toast) {
    try {
        navigator.clipboard.writeText(hrn);
        toast(translations.data["venonboard.mapCollectionTab.collectionUrl"], translations.data["venonboard.mapCollection.notification"], 3, "positive", "solid");
    }
    catch (e) { }
};
export var disableDropdownItems = function (hrn, realm) {
    var dropdownItems = [];
    isSharedCollectionHrn(hrn, realm) &&
        dropdownItems.push(MAP_COLLECTION_DROPDOWN_VALUES.REFRESH_COLLECTION);
    return dropdownItems;
};
export var downloadCollection = function (hrn, toast) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var token, res, snapshotTime, downloadCollectionResponse, jsonResponse, blob, url, link, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = getState().user.token;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, getSnapshots(token, hrn)];
            case 2:
                res = _a.sent();
                snapshotTime = new Date(res === null || res === void 0 ? void 0 : res.data.snapshotTimes[0]).getTime();
                return [4 /*yield*/, getAllCollectionData(token, hrn, snapshotTime, dispatch)];
            case 3:
                downloadCollectionResponse = _a.sent();
                jsonResponse = JSON.stringify(downloadCollectionResponse);
                blob = new Blob([jsonResponse], { type: "application/json" });
                url = URL.createObjectURL(blob);
                link = document.createElement("a");
                link.download = INDOOR_MAP.DOWNLOAD_COLLECTION_FILE_NAME;
                link.href = url;
                link.click();
                return [3 /*break*/, 5];
            case 4:
                e_1 = _a.sent();
                toast(DOWNLOAD_COLLECTION_TOAST.TITLE, DOWNLOAD_COLLECTION_TOAST.MESSAGE.DOWNLOAD_COLLECTION_FAILURE, 3, "error");
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
export var refreshCollection = function (hrn, toast) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var token, getSnaps, _a, e_2;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                token = getState().user.token;
                _d.label = 1;
            case 1:
                _d.trys.push([1, 9, , 10]);
                if (!!isSharedCollectionHrn) return [3 /*break*/, 2];
                toast(REFRESH_COLLECTION_TOAST.TITLE, REFRESH_COLLECTION_TOAST.MESSAGE.SHARED_COLLECTION, 3, "error");
                return [3 /*break*/, 8];
            case 2: return [4 /*yield*/, getSnapshots(token, hrn)];
            case 3:
                getSnaps = _d.sent();
                if (!((_c = (_b = getSnaps === null || getSnaps === void 0 ? void 0 : getSnaps.data) === null || _b === void 0 ? void 0 : _b.snapshotTimes) === null || _c === void 0 ? void 0 : _c.includes(INDOOR_MAP.DEFAULT_SNAPSHOT_TIME))) return [3 /*break*/, 5];
                return [4 /*yield*/, refreshDefaultLayer(token, hrn)];
            case 4:
                _a = _d.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, postSnapshots(token, hrn)];
            case 6:
                _a = _d.sent();
                _d.label = 7;
            case 7:
                _a;
                toast(REFRESH_COLLECTION_TOAST.TITLE, REFRESH_COLLECTION_TOAST.MESSAGE.REFRESH_COLLECTION_SUCCESS, 3, "warning");
                _d.label = 8;
            case 8: return [3 /*break*/, 10];
            case 9:
                e_2 = _d.sent();
                toast(REFRESH_COLLECTION_TOAST.TITLE, REFRESH_COLLECTION_TOAST.MESSAGE.REFRESH_COLLECTION_FAILURE, 3, "error");
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}); }; };
export var viewReport = function (hrn, toast) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var token, res, snapshotTime, viewReport_1, jsonResponse, blob, url, link, e_3;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                token = getState().user.token;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 6, , 7]);
                return [4 /*yield*/, getSnapshots(token, hrn)];
            case 2:
                res = _c.sent();
                if (!(((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.snapshotTimes.length) !== 0)) return [3 /*break*/, 4];
                snapshotTime = new Date((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.snapshotTimes[0]).getTime();
                return [4 /*yield*/, viewCheckinReport(token, hrn, snapshotTime)];
            case 3:
                viewReport_1 = _c.sent();
                jsonResponse = JSON.stringify(viewReport_1);
                blob = new Blob([jsonResponse], { type: "application/json" });
                url = URL.createObjectURL(blob);
                link = document.createElement("a");
                link.download = INDOOR_MAP.DOWNLOAD_CHECKIN_REPORT_FILE_NAME;
                link.href = url;
                link.click();
                return [3 /*break*/, 5];
            case 4:
                toast(VIEW_CHECKIN_REPORT_TOAST.TITLE, VIEW_CHECKIN_REPORT_TOAST.MESSAGE.VIEW_CHECKIN_REPORT_FAILURE, 3, "error");
                _c.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                e_3 = _c.sent();
                toast(VIEW_CHECKIN_REPORT_TOAST.TITLE, VIEW_CHECKIN_REPORT_TOAST.MESSAGE.VIEW_CHECKIN_REPORT_FAILURE, 3, "error");
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}); }; };
export var downloadStubLinkReport = function (hrn, toast) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var token, res, qaReport, stubLinkReport, blob, url, link, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = getState().user.token;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, getQAReport(token, hrn)];
            case 2:
                res = _a.sent();
                qaReport = res.data;
                if (qaReport.live) {
                    stubLinkReport = generateStubLinkReport(qaReport.live);
                    blob = new Blob([stubLinkReport], {
                        type: "text/csv;charset=utf-8",
                    });
                    url = URL.createObjectURL(blob);
                    link = document.createElement("a");
                    link.download = INDOOR_MAP.DOWNLOAD_CHECKIN_REPORT_FILE_NAME;
                    link.href = url;
                    link.click();
                }
                else {
                    toast(DOWNLOAD_STUB_LINK_TOAST.TITLE, DOWNLOAD_STUB_LINK_TOAST.MESSAGE.DOWNLOAD_STUB_LINK_FAILURE, 3, "error");
                }
                return [3 /*break*/, 4];
            case 3:
                e_4 = _a.sent();
                toast(DOWNLOAD_STUB_LINK_TOAST.TITLE, e_4.message, 3, "error");
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var viewQAReport = function (hrn, toast) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var token, res, qaReport, myWindow, html, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = getState().user.token;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, getQAReport(token, hrn)];
            case 2:
                res = _a.sent();
                if (res.data.live) {
                    qaReport = JSON.stringify(res.data.live);
                    myWindow = window.open("", "", "width=200,height=100");
                    html = qaReport;
                    myWindow.document.write(html);
                }
                else {
                    toast(DOWNLOAD_STUB_LINK_TOAST.TITLE, DOWNLOAD_STUB_LINK_TOAST.MESSAGE.DOWNLOAD_STUB_LINK_FAILURE, 3, "error");
                }
                return [3 /*break*/, 4];
            case 3:
                e_5 = _a.sent();
                toast(VIEW_QA_REPORT_TOAST.TITLE, e_5.message, 3, "error");
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var copyText = function (text) {
    try {
        navigator.clipboard.writeText(text);
        utils.notify(translations.data["venonboard.internalToolsTab3"], translations.data["venonboard.mapOrders.copyNotification"], 3, NOTIFICATION_VARIANT.WARN, "solid");
    }
    catch (e) { }
};
export var handleEdit = function (hostName, hrn) {
    var url = "https://".concat(hostName, "/indoor-map-creator/?cat=").concat(hrn);
    window.open(url);
};
export var downloadAttributeQAReport = function (hrn, mapId, toast, setShowModal) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var token, mapDataRes, mapData, mom, report, blob, url, link, e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = getState().user.token;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                setShowModal(true);
                return [4 /*yield*/, getMomFromIML(token, hrn)];
            case 2:
                mapDataRes = _a.sent();
                if (mapDataRes && mapDataRes.features.length > 0) {
                    mapData = JSON.stringify(mapDataRes);
                    mom = JSON.parse(mapData);
                    report = generateAttributeCount(mom);
                    blob = new Blob([report.toString()], {
                        type: "text/csv;charset=utf-8",
                    });
                    url = URL.createObjectURL(blob);
                    link = document.createElement("a");
                    link.download = "".concat(mapId, "_QAR");
                    link.href = url;
                    link.click();
                    setShowModal(false);
                }
                else {
                    setShowModal(false);
                    toast({
                        title: translations.data["venonboard.internalTools.buttonAttributeQAReport"],
                        body: translations.data["venonboard.attributeQAReport.noMapData"],
                        duration: "10",
                        status: "error",
                        variant: "solid",
                    });
                }
                return [3 /*break*/, 4];
            case 3:
                e_6 = _a.sent();
                setShowModal(false);
                toast(translations.data["venonboard.internalTools.buttonAttributeQAReport"], "failed to generate report - ".concat(e_6), "10", "error", "solid");
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var copyMapId = function (text) {
    navigator.clipboard.writeText(text);
    utils.notify("", translations.data["venonboard.internalTools.copyMapID"], 3, "positive", "solid");
};
